<template>
    <div>
        <rkm-area
            v-if="pacienteExists"
            title="Paciente"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col
                    v-if="showAvatar"
                    align-self="center"
                    class="col-svg flex-grow-0"
                >
                    <rkm-icon class="icon" icon="user"/>
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-row>
                        <rkm-col>
                            <h4>
                                {{ data.form.paciente.cidadao.nome }}
                                <strong v-if="data.form.paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                                    ({{ data.form.paciente.nomeSocial }})
                                </strong>
                            </h4>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <p>
                                <strong>Prontuário:</strong>
                                {{ data.form.paciente.prontuario }}
                            </p>
                            <p>
                                <strong>CPF:</strong>
                                {{ data.form.paciente.cidadao.cpf | formatCpf }}
                            </p>
                            <p>
                                <strong>CNS:</strong>
                                {{ data.form.paciente.cidadao.cns | formatCns }}
                            </p>
                        </rkm-col>

                        <rkm-col cols="3">
                            <p>
                                <strong>Telefone:</strong>
                                <template v-if="data.form.paciente.cidadao.telefonePrincipal">
                                    {{ data.form.paciente.cidadao.telefonePrincipal.numero | formatPhoneOrCellPhone }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>
                                <strong>Data de nascimento:</strong>
                                {{ data.form.paciente.cidadao.dataNascimento | formatDate }}
                            </p>
                            <p>
                                <strong>Idade:</strong>
                                <template v-if="data.form.paciente.cidadao.idade">
                                    {{ data.form.paciente.cidadao.idade.anos }} anos,
                                    {{ data.form.paciente.cidadao.idade.meses }} meses e
                                    {{ data.form.paciente.cidadao.idade.dias }} dias
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>Sexo:</strong>
                                <template v-if="data.form.paciente.cidadao.sexo">
                                    {{ data.form.paciente.cidadao.sexo.descricao }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>
                                <strong>
                                    Nome da mãe:
                                </strong>
                                <template v-if="data.form.paciente.cidadao.nomeMae">
                                    {{ data.form.paciente.cidadao.nomeMae }}
                                </template>
                                <template v-else>
                                    <i>Desconhecido</i>
                                </template>
                            </p>
                            <p>
                                <strong>Unidade de referência:</strong>
                                <template v-if="data.form.paciente.unidade && data.form.paciente.unidade.nomeFantasia">
                                    {{ data.form.paciente.unidade.nomeFantasia }}
                                </template>
                                <template v-else>
                                    <i> Não informado no cadastro do paciente</i>
                                </template>
                            </p>
                        </rkm-col>
                        <rkm-col cols="3">
                            <p>
                                <strong>Endereço:</strong>
                                <template v-if="data.form.paciente.cidadao && data.form.paciente.cidadao.domicilio && data.form.paciente.cidadao.domicilio.endereco">
                                    {{ data.form.paciente.cidadao.domicilio.endereco.logradouro.nome }},
                                    {{ data.form.paciente.cidadao.domicilio.endereco.numero }},
                                    {{ data.form.paciente.cidadao.domicilio.endereco.logradouro.bairro.nome }},
                                    {{ data.form.paciente.cidadao.domicilio.endereco.logradouro.municipio.nome }} -
                                    {{ data.form.paciente.cidadao.domicilio.endereco.logradouro.municipio.estado.nome }},
                                    CEP: {{ data.form.paciente.cidadao.domicilio.endereco.logradouro.cep | formatCep }}
                                </template>
                                <template v-else>
                                    Não informado
                                </template>
                            </p>
                            <p>
                                <strong>Area:</strong>
                                <template v-if="data.form.paciente.responsavel && data.form.paciente.responsavel.equipe && data.form.paciente.responsavel.equipe.area && data.form.paciente.responsavel.equipe.area.descricao">
                                     {{ data.form.paciente.responsavel.equipe.area.descricao }}
                                </template>
                                <template v-else>
                                     Não Informada
                                </template>
                            </p>
                            <p>
                                <strong>MicroArea: </strong>
                                <template v-if="data.form.paciente.responsavel && data.form.paciente.responsavel.equipe && data.form.paciente.responsavel.equipe.microarea">
                                    {{ data.form.paciente.responsavel.equipe.microarea.descricao }}
                                </template>
                                <template v-else>
                                    Não Informada
                                </template>
                            </p>
                            <p>
                                <strong>INE: </strong>
                                <template v-if="data.form.paciente.responsavel && data.form.paciente.responsavel.equipe && data.form.paciente.responsavel.equipe.area">
                                    {{ data.form.paciente.responsavel.equipe.area.numeroIne }}
                                </template>
                                <template v-else>
                                    Não Informado
                                </template>
                            </p>
                            <p>
                                <strong>Responsável: </strong>
                                <template v-if="data.form.paciente.responsavel && data.form.paciente.responsavel.usuario">
                                    {{ data.form.paciente.responsavel.usuario.cidadao.nome }}
                                </template>
                                <template v-else>
                                    Não Informado
                                </template>
                            </p>
                            <p>
                                <strong>Data da última atualização:</strong>
                                <template v-if="data.form.ultimaAtualizacaoCadastral">
                                    {{ data.form.ultimaAtualizacaoCadastral }}
                                </template>
                                <template v-else>
                                    Não Informada
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>
            </rkm-row>

            <rkm-form
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            label="Observações"
                            v-model="data.model.paciente.observacao"
                            :validations="validations.observacao"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>
    </div>
</template>

<script>

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Filters.
import formats from '@/filters/formats'

export default {
    computed: {
        pacienteExists() {
            return this.data.form && this.data.form.paciente
        },
        validations() {

            return {
                observacao: { min: 3, max: 300 }
            }
        }
    },
    data: () => ({
        enums: { preferenciaNome },
    }),
    filters: {
        ...formats,
    },
    methods: {
        validate() {

            return this.$refs.RkmForm.validate()
        }
    },
    props: {
        data: { type: Object, required: true },
        showAvatar: { type: Boolean, default: false }
    },
}
</script>

<style scoped>
p {
    margin: 0px;
}
.col-svg {
    text-align: center !important;
}
.icon {
    width: auto !important;
    height: 96px !important;
    color: #007bff !important;
}
</style>